import { get } from 'lodash';
import React from 'react';
import { ANTRAGS_FORMULAREN, KOSTEN_ARTEN, KOSTEN_POSITION, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureSkizzeFinanzierungPlanGlobal } from '../../global-structure/finanzierung-plan-skizze/TreeStructureSkizzeFinanzierungPlanGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureSkizzeVerbundpartnerGlobal } from '../../global-structure/verbundpartner-skizze/TreeStructureSkizzeVerbundpartnerGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import EigenmittelUebersichtSkizzeEmob from './content/Eigenmittel/EinnahmeUebersichtSkizze';
import { GetEigenmittelSkizzeEmob } from './content/Eigenmittel/GetEigenmittelSkizzeEmob';
import AnwendungAusblickSkizzeEmob, {
	getFormStrucAnwendungAusblickSkizzeEmob,
} from './content/Projektbeschreibung/emob-forschung/AnwendungAusblickSkizze';
import AusgangssituationSkizzeEmob, {
	getFormStrucAusgangssituationSkizzeEmob,
} from './content/Projektbeschreibung/emob-forschung/AusgangssituationForschungSkizze';
import BeschreibungVorhabensSkizzeEmob, {
	getFormStrucBeschreibungVorhabensSkizzeEmob,
} from './content/Projektbeschreibung/emob-forschung/BeschreibungVorhabensForschungSkizze';
import MarktausblickSkizzeEmob, {
	getFormStrucMarktausblickSkizzeEmob,
} from './content/Projektbeschreibung/emob-forschung/MarktausblickForschungSkizze';
import SwotSkizzeEmob, { getFromStrucSwotSkizzeEmob } from './content/Projektbeschreibung/emob-forschung/StaerkenSchaechenForschungSkizze';
import ProjektDatenSkizzeEmob, { getFormStrucProjektDatenSkizzeEmob } from './content/ProjektdatenSkizzeEmob';
import { GetPersonalKostenSkizzeEmob } from './content/personalkosten/GetPersonalKostenSkizzeEmob';
import PersonalkostenUebersichtSkizzeEmob from './content/personalkosten/PersonalkostenUebersichtSkizzeEmob';
import { GetSachkostenSkizzeEmob } from './content/sachkosten/GetSachkostenSkizzeEmob';
import SachkostenUebersichtSkizzeEmob from './content/sachkosten/SachkostenUebersichtSkizzeEmob';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const TreeStructureSkizzeEmob = (
	application: any,
	kostenKategories: any,
	readOnly: boolean,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
) => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// Allgemeine Hinweise Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Projektdaten
		{
			label: 'Projektdaten',
			content: <ProjektDatenSkizzeEmob hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektDatenSkizzeEmob(application, readOnly),
			hasComment: hasCommentProjektdaten,
		},
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Partner Global
		...TreeStructureSkizzeVerbundpartnerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Projektbrschreibung
		...ProjektBeschreibungStructure(application, readOnly),
		// KostenPositions
		...PersonalKostenStructure(application, kostenKategories, readOnly, isKostenEditable),
		...SachKostenStructure(application, kostenKategories, readOnly, isKostenEditable),
		...EigenmittelStructure(application, kostenKategories, readOnly, isKostenEditable),
		...TreeStructureSkizzeFinanzierungPlanGlobal(application, isKostenEditable),
		// Zeitplaung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Anlagen und Erkläruing Global
		...TreeStructureErklaerungGlobal(application, readOnly),
		...TreeStructureAnlagenGlobal(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
	];

	return treeNodes;
};

const ProjektBeschreibungStructure = (application: any, readOnly: boolean) => {
	if (get(application, P.Allgemein_Antragsformular.path, '') === ANTRAGS_FORMULAREN.EmobFundE) {
		const hasCommentAusgangssituation = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0213069123_tuation_Pruefung_Pruefstatus.path,
		);
		const hasCommentBeschreibungProjektziels = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0089835347_rhabens_Pruefung_Pruefstatus.path,
		);
		const hasCommentMarktausblick = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0089835347_rhabens_Pruefung_Pruefstatus.path,
		);
		const hasCommentAnwendungAusblick = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0149595523_wertung_Pruefung_Pruefstatus.path,
		);
		const hasCommentSwot = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0260019443_erungen_Pruefung_Pruefstatus.path,
		);
		return [
			{
				label: 'Projektbeschreibung',
				content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
				hasComment:
					(
						hasCommentAusgangssituation ||
						hasCommentBeschreibungProjektziels ||
						hasCommentMarktausblick ||
						hasCommentAnwendungAusblick ||
						hasCommentSwot
					) ?
						true
					:	false,
				children: [
					{
						label: 'Ausgangssituation',
						content: <AusgangssituationSkizzeEmob hasComment={hasCommentAusgangssituation} />,
						hasComment: hasCommentAusgangssituation,
						formStruc: getFormStrucAusgangssituationSkizzeEmob(application, readOnly),
					},
					{
						label: 'Beschreibung des Projektziels',
						content: <BeschreibungVorhabensSkizzeEmob hasComment={hasCommentBeschreibungProjektziels} />,
						hasComment: hasCommentBeschreibungProjektziels,
						formStruc: getFormStrucBeschreibungVorhabensSkizzeEmob(application, readOnly),
					},
					{
						label: 'Innovationsgrad und Alleinstellungsmerkmale',
						content: <MarktausblickSkizzeEmob hasComment={hasCommentMarktausblick} />,
						hasComment: hasCommentMarktausblick,
						formStruc: getFormStrucMarktausblickSkizzeEmob(application, readOnly),
					},
					{
						label: 'Anwendung und Ausblick',
						content: <AnwendungAusblickSkizzeEmob hasComment={hasCommentAnwendungAusblick} />,
						hasComment: hasCommentAnwendungAusblick,
						formStruc: getFormStrucAnwendungAusblickSkizzeEmob(application, readOnly),
					},
					{
						label: 'SWOT',
						content: <SwotSkizzeEmob hasComment={hasCommentSwot} />,
						hasComment: hasCommentSwot,
						formStruc: getFromStrucSwotSkizzeEmob(application, readOnly),
					},
				],
			},
		];
	}
	return [];
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		return [
			{
				label: 'Personalkosten',
				content: <ApplicationHeading title='Personalkosten' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				children: GetPersonalKostenSkizzeEmob(application, hasCommentAusgabenUndFinanzierung),
			},
			{ label: 'Personalkosten Übersicht', content: <PersonalkostenUebersichtSkizzeEmob />, isSummaryReport: true },
		];
	}
	return [];
};
const SachKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		return [
			{
				label: 'Sachausgaben',
				content: <ApplicationHeading title='Sachausgaben' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				children: GetSachkostenSkizzeEmob(application, hasCommentAusgabenUndFinanzierung),
			},
			{ label: 'Sachausgaben Übersicht', content: <SachkostenUebersichtSkizzeEmob />, isSummaryReport: true },
		];
	}
	return [];
};
const EigenmittelStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		return [
			{
				label: 'Eigen- und Drittmittel',
				content: <ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				children: GetEigenmittelSkizzeEmob(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Eigen- und Drittmittel Übersicht',
				content: <EigenmittelUebersichtSkizzeEmob />,
				isSummaryReport: true,
			},
		];
	}
	return [];
};
